import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'app-address-card',
    templateUrl: './address-card.component.svg',
    styleUrls: ['./address-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddressCardComponent {}
